module.exports = __webpack_public_path__ + "img/icon_hs.67493d96.png";